import { lazy } from 'react'

const QuestionBubble = lazy(() => import('./icons/question-bubble'))
const MedicalHandCard = lazy(() => import('./icons/medical-hand-card'))
const UserHeartHealth = lazy(() => import('./icons/user-heart-health'))
const Camera = lazy(() => import('./icons/camera'))
const FinalCalendar = lazy(() => import('./icons/final-calendar'))
const InitialCalendar = lazy(() => import('./icons/initial-calendar'))
const Notification = lazy(() => import('./icons/notification'))
const MedicineFolder = lazy(() => import('./icons/medicine-folder'))
const Home = lazy(() => import('./icons/home'))
const PeopleParticipants = lazy(() => import('./icons/people-participants'))
const ArrowRight = lazy(() => import('./icons/arrow-right'))
const ArrowDown = lazy(() => import('./icons/arrow-down'))
const ArrowUp = lazy(() => import('./icons/arrow-up'))
const DoctorTalk = lazy(() => import('./icons/doctor-talk'))
const MedicineSearch = lazy(() => import('./icons/medicine-search'))
const Stethoscope = lazy(() => import('./icons/stethoscope'))
const MedicineShield = lazy(() => import('./icons/medicine-shield'))
const ArrowLeft = lazy(() => import('./icons/arrow-left'))
const ArrowLeftVariant = lazy(() => import('./icons/arrow-left-variant'))
const Search = lazy(() => import('./icons/search'))
const Loading = lazy(() => import('./icons/loading'))
const Calendar = lazy(() => import('./icons/calendar'))
const Clock = lazy(() => import('./icons/clock'))
const Profile = lazy(() => import('./icons/profile'))
const Star = lazy(() => import('./icons/star'))
const StarFilled = lazy(() => import('./icons/star-filled'))
const Close = lazy(() => import('./icons/close'))
const ConexaLogo = lazy(() => import('./icons/conexa-logo'))
const FileBlank = lazy(() => import('./icons/file-blank'))
const FileCheck = lazy(() => import('./icons/file-check'))
const FileError = lazy(() => import('./icons/file-error'))
const Clip = lazy(() => import('./icons/clip'))
const Plus = lazy(() => import('./icons/plus'))
const ArrowGroup = lazy(() => import('./icons/arrow-group'))
const Silhouette = lazy(() => import('./icons/silhouette'))
const Info = lazy(() => import('./icons/info'))
const Back = lazy(() => import('./icons/back'))
const Warning = lazy(() => import('./icons/warning'))
const Trash = lazy(() => import('./icons/trash'))
const Medicine = lazy(() => import('./icons/medicine'))
const Edit = lazy(() => import('./icons/edit'))
const Applause = lazy(() => import('./icons/applause'))
const ClockRefresh = lazy(() => import('./icons/clock-refresh'))
const Diamond = lazy(() => import('./icons/diamond'))
const HeartCheck = lazy(() => import('./icons/heart-check'))
const Play = lazy(() => import('./icons/play'))
const Settings = lazy(() => import('./icons/settings'))
const SwipeRight = lazy(() => import('./icons/swipe-right'))
const VolumeFull = lazy(() => import('./icons/volume-full'))
const AttachCircle = lazy(() => import('./icons/attach-circle'))
const Dot = lazy(() => import('./icons/dot'))
const Check = lazy(() => import('./icons/check'))
const EyeOn = lazy(() => import('./icons/eye-on'))
const EyeOff = lazy(() => import('./icons/eye-off'))
const CreditCards = lazy(() => import('./icons/credit-cards'))
const Amex = lazy(() => import('./icons/amex'))
const Discover = lazy(() => import('./icons/discover'))
const Visa = lazy(() => import('./icons/visa'))
const MasterCard = lazy(() => import('./icons/mastercard'))
const Headphone = lazy(() => import('./icons/headphone'))
const Flag = lazy(() => import('./icons/flag'))
const Card = lazy(() => import('./icons/card'))
const NewCard = lazy(() => import('./icons/new-card'))
const InsuranceCard = lazy(() => import('./icons/insurance-card'))
const Benefits = lazy(() => import('./icons/benefits'))
const LifeInsurance = lazy(() => import('./icons/life-insurance'))
const HealthBenefit = lazy(() => import('./icons/health-benefit'))
const LabBenefit = lazy(() => import('./icons/lab-benefit'))
const MedicalNotes = lazy(() => import('./icons/medical-notes'))
const Positive = lazy(() => import('./icons/positive'))
const Negative = lazy(() => import('./icons/negative'))
const MedicalNote = lazy(() => import('./icons/medical-note'))
const ShiningHeart = lazy(() => import('./icons/shining-heart'))
const Beat = lazy(() => import('./icons/beat'))
const CircleCheck = lazy(() => import('./icons/circle-check'))
const MedicalCross = lazy(() => import('./icons/medical-cross'))

// Ilustrations
const CharacterClipboard = lazy(() =>
  import('./ilustrations/character-clipboard'),
)
const ConsultationsCalendar = lazy(() =>
  import('./ilustrations/consultations-calendar'),
)
const CancellationCalendar = lazy(() =>
  import('./ilustrations/cancellation-calendar'),
)
const Medic = lazy(() => import('./ilustrations/medico'))
const SocialAssistant = lazy(() => import('./ilustrations/assistente_social'))
const Psychologist = lazy(() => import('./ilustrations/psicologo'))
const Dentist = lazy(() => import('./ilustrations/dentista'))
const ApsBackGround = lazy(() => import('./ilustrations/aps-background'))
const Physiotherapist = lazy(() => import('./ilustrations/fisioterapeuta'))
const SpeechTherapist = lazy(() => import('./ilustrations/fonoaudiologo'))
const Nutritionist = lazy(() => import('./ilustrations/nutricionista'))
const Nurse = lazy(() => import('./ilustrations/enfermeiro'))
const CharacterMediaPlayer = lazy(() =>
  import('./ilustrations/character-media-player'),
)
const CharacterSuccessCheck = lazy(() =>
  import('./ilustrations/character-success-check'),
)
const PViva = lazy(() => import('./ilustrations/pv'))
const WomanCancelingSchedule = lazy(() =>
  import('./ilustrations/woman-canceling-schedule'),
)
const WomanCheckoutConfirmed = lazy(() =>
  import('./ilustrations/woman-checkout-confirmed'),
)
const ManCancelingSchedule = lazy(() =>
  import('./ilustrations/man-canceling-schedule'),
)
const TimeCancelingSchedule = lazy(() =>
  import('./ilustrations/time-canceling-schedule'),
)
const WomanUsingNotebook = lazy(() =>
  import('./ilustrations/woman-using-notebook'),
)
const ManMobileWifi = lazy(() => import('./ilustrations/man-mobile-wifi'))
const WomanUsingCellphone = lazy(() =>
  import('./ilustrations/woman-using-cellphone'),
)
const CharacterHandPocket = lazy(() =>
  import('./ilustrations/character-hand-pocket'),
)
const CharacterMicrophoneCamera = lazy(() =>
  import('./ilustrations/character-microphone-camera'),
)
const WomanMicAndCam = lazy(() => import('./ilustrations/woman-mic-and-cam'))
const CardExpirationDate = lazy(() =>
  import('./ilustrations/card-expiration-date'),
)
const CardCVV = lazy(() => import('./ilustrations/card-cvv'))
const DoctorWithCalendar = lazy(() =>
  import('./ilustrations/doctor-with-calendar'),
)
const DoctorWithCalendarSecondary = lazy(() =>
  import('./ilustrations/doctor-with-calendar-secondary'),
)
const DoctorWithCancellation = lazy(() =>
  import('./ilustrations/doctor-with-cancellation'),
)
const CanceledModalWoman = lazy(() =>
  import('./ilustrations/canceled-modal-woman'),
)
const CharacterErrorPlayer = lazy(() =>
  import('./ilustrations/character-error-check'),
)
const CharacterWaiting = lazy(() => import('./ilustrations/character-waiting'))
const ManWithMoney = lazy(() => import('./ilustrations/man-with-money'))
const ManMeditating = lazy(() => import('./ilustrations/man-meditating'))
const WomanDoingYoga = lazy(() => import('./ilustrations/woman-doing-yoga'))
const ManReadingBook = lazy(() => import('./ilustrations/man-reading-book'))
const WomanSleepingHoldingCoffee = lazy(() =>
  import('./ilustrations/woman-sleeping-holding-coffee'),
)
const WomanHoldingBaby = lazy(() => import('./ilustrations/woman-holding-baby'))
const ManSpeaking = lazy(() => import('./ilustrations/man-speaking'))
const ManInASuitWithPhone = lazy(() =>
  import('./ilustrations/man-in-a-suit-with-phone'),
)
const ManHoldingPhone = lazy(() => import('./ilustrations/man-holding-phone'))
const DoctorSearching = lazy(() => import('./ilustrations/doctor-searching'))
const ConexaPlus = lazy(() => import('./ilustrations/conexa-plus'))
const UserHoldingPhoneSuccess = lazy(() =>
  import('./ilustrations/user-holding-phone-success'),
)
const UserHoldingPhoneWarning = lazy(() =>
  import('./ilustrations/user-holding-phone-warning'),
)
const UserHoldingPhoneError = lazy(() =>
  import('./ilustrations/user-holding-phone-error'),
)
const UpdateAccountDataRibon = lazy(() =>
  import('./ilustrations/update-account-ribon'),
)
const WomanExercising = lazy(() => import('./ilustrations/woman-exercising'))

export default {
  // Icons
  'question-bubble': QuestionBubble,
  'medical-hand-card': MedicalHandCard,
  'user-heart-health': UserHeartHealth,
  'final-calendar': FinalCalendar,
  'initial-calendar': InitialCalendar,
  notification: Notification,
  'medicine-folder': MedicineFolder,
  home: Home,
  'arrow-right': ArrowRight,
  'arrow-group': ArrowGroup,
  camera: Camera,
  'arrow-down': ArrowDown,
  'arrow-up': ArrowUp,
  calendar: Calendar,
  clock: Clock,
  profile: Profile,
  star: Star,
  'star-filled': StarFilled,
  close: Close,
  'doctor-talk': DoctorTalk,
  'medicine-search': MedicineSearch,
  stethoscope: Stethoscope,
  'medicine-shield': MedicineShield,
  search: Search,
  loading: Loading,
  'conexa-logo': ConexaLogo,
  'arrow-left': ArrowLeft,
  'arrow-left-variant': ArrowLeftVariant,
  'file-blank': FileBlank,
  'file-check': FileCheck,
  'file-error': FileError,
  'medical-notes': MedicalNotes,
  clip: Clip,
  warning: Warning,
  medicine: Medicine,
  trash: Trash,
  edit: Edit,
  dot: Dot,
  check: Check,
  'people-participants': PeopleParticipants,
  'eye-on': EyeOn,
  'eye-off': EyeOff,
  plus: Plus,
  'credit-cards': CreditCards,
  amex: Amex,
  discover: Discover,
  visa: Visa,
  mastercard: MasterCard,
  headphone: Headphone,
  flag: Flag,
  card: Card,
  'new-card': NewCard,
  'insurance-card': InsuranceCard,
  'medical-note': MedicalNote,
  'shining-heart': ShiningHeart,
  beat: Beat,
  'circle-check': CircleCheck,
  'medical-cross': MedicalCross,

  // Ilustrations
  silhouette: Silhouette,
  info: Info,
  applause: Applause,
  'clock-refresh': ClockRefresh,
  diamond: Diamond,
  'heart-check': HeartCheck,
  play: Play,
  settings: Settings,
  'swipe-right': SwipeRight,
  'volume-full': VolumeFull,
  back: Back,
  'character-clipboard': CharacterClipboard,
  'consultations-calendar': ConsultationsCalendar,
  'cancellation-calendar': CancellationCalendar,
  'character-media-player': CharacterMediaPlayer,
  medico: Medic,
  dentista: Dentist,
  'aps-BackGround': ApsBackGround,
  psicologo: Psychologist,
  fisioterapeuta: Physiotherapist,
  fonoaudiologo: SpeechTherapist,
  nutricionista: Nutritionist,
  assistente_social: SocialAssistant,
  enfermeiro: Nurse,
  'character-success-check': CharacterSuccessCheck,
  pviva: PViva,
  'woman-canceling-schedule': WomanCancelingSchedule,
  'woman-checkout-confirmed': WomanCheckoutConfirmed,
  'man-canceling-schedule': ManCancelingSchedule,
  'time-canceling-schedule': TimeCancelingSchedule,
  'woman-using-notebook': WomanUsingNotebook,
  'man-mobile-wifi': ManMobileWifi,
  'woman-using-cellphone': WomanUsingCellphone,
  'character-hand-pocket': CharacterHandPocket,
  'character-microphone-camera': CharacterMicrophoneCamera,
  'attach-circle': AttachCircle,
  'card-expiration-date': CardExpirationDate,
  'card-cvv': CardCVV,
  'woman-mic-and-cam': WomanMicAndCam,
  'doctor-with-calendar': DoctorWithCalendar,
  'doctor-with-calendar-secondary': DoctorWithCalendarSecondary,
  'doctor-with-cancellation': DoctorWithCancellation,
  'canceled-modal-woman': CanceledModalWoman,
  'character-error-check': CharacterErrorPlayer,
  'benefits-icon-menu': Benefits,
  'life-insurance': LifeInsurance,
  'health-benefit': HealthBenefit,
  'lab-benefit': LabBenefit,
  positive: Positive,
  negative: Negative,
  'character-waiting': CharacterWaiting,
  'man-with-money': ManWithMoney,
  'man-meditating': ManMeditating,
  'woman-doing-yoga': WomanDoingYoga,
  'man-reading-book': ManReadingBook,
  'woman-sleeping-holding-coffee': WomanSleepingHoldingCoffee,
  'woman-holding-baby': WomanHoldingBaby,
  'man-speaking': ManSpeaking,
  'man-in-a-suit-with-phone': ManInASuitWithPhone,
  'man-holding-phone': ManHoldingPhone,
  'doctor-searching': DoctorSearching,
  'conexa-plus': ConexaPlus,
  'user-holding-phone-success': UserHoldingPhoneSuccess,
  'user-holding-phone-warning': UserHoldingPhoneWarning,
  'user-holding-phone-error': UserHoldingPhoneError,
  'characters-talking-conexa-ribon': UpdateAccountDataRibon,
  'woman-exercising': WomanExercising,
}
